var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dms-select',_vm._b({attrs:{"select-list":_vm.selectList,"value":_vm.valueCmp,"label-key":_vm.labelText},on:{"update:value":function($event){_vm.valueCmp=$event}}},'dms-select',{span: _vm.span, clearable: false},false))}
var staticRenderFns = []

export { render, staticRenderFns }